module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"back":"Gehen Sie zur Homepage","notFound":"Seite nicht gefunden"},"en":{"back":"Go to homepage","notFound":"Page not found"},"it":{"back":"","notFound":""},"lt":{"back":"Eiti į pagrindinį puslapį","notFound":"Puslapis nerastas"},"pl":{"back":"Przejdź do strony głównej","notFound":"Nie odnaleziono strony"}}')
  delete Component.options._Ctor
}
